import React from 'react';

import PropTypes from 'prop-types';

import { Badge } from 'apps/auth/components/common/Badge/Badge';
import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { DiskBadgeWrapper, PanelContent, PanelRightBlock, PanelRow } from 'apps/auth/components/common/Panel/styles';
import { Text } from 'apps/auth/components/common/Text/Text';
import { requestPaymentMethods } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

import ActionBanner from './ActionBanner';

const AddEmptySource = (props) => {
    const { requestDeliveryCard, requestDeliveryBankAccount, paymentsCardTitle } = usePageMessages();
    const { paySystemsTo } = useExtra();
    const method = props.isAccount ? requestPaymentMethods.NEW_ACCOUNT : requestPaymentMethods.NEW_CARD;

    const getPaySystemsLabel = () => {
        const capitalizedPaySystems = paySystemsTo.map((paySystem) => {
            return paySystem.charAt(0).toUpperCase() + paySystem.slice(1).toLowerCase();
        });

        if (capitalizedPaySystems.length === 1) {
            return `${capitalizedPaySystems[0]} only`;
        }

        const lastIndex = capitalizedPaySystems.length - 1;
        const commaSeparatedPaySystems = capitalizedPaySystems.slice(0, lastIndex);
        return commaSeparatedPaySystems.join(', ') + ` or ${capitalizedPaySystems[lastIndex]}`;
    };

    const handlePanelClick = () => {
        if (props.isAccount) {
            props.setIsNewAccount(true);
        }
        if (props.actionBanner && props.popupRef?.current) {
            props.popupRef.current?.open(
                <ActionBanner
                    amplitudePaymentMethodEvent={props.amplitudePaymentMethodEvent}
                    method={method}
                    actionBanner={props.actionBanner}
                    popupRef={props.popupRef}
                    handleClick={props.onClick}
                />,
            );
        } else {
            props.amplitudePaymentMethodEvent(method);
            props.onClick();
        }
    };

    const getTitle = () => {
        if (props.isAccount) {
            return requestDeliveryBankAccount;
        }
        if (!props.isCreate && !props.isAccount) {
            return paymentsCardTitle;
        }
        return requestDeliveryCard;
    };

    return (
        <Panel type="div" onClick={handlePanelClick} isHoverable negativeMargin>
            <DiskBadgeWrapper>
                <DiskBadge variant="secondary" iconName={props.isAccount ? 'bank' : 'card'} />
            </DiskBadgeWrapper>
            <PanelContent>
                <PanelRow>{getTitle()}</PanelRow>
                {!props.isAccount && paySystemsTo && (
                    <PanelRow>
                        <Text size="secondary" color="secondary">
                            {getPaySystemsLabel()}
                        </Text>
                    </PanelRow>
                )}
            </PanelContent>
            {props.badge ? (
                <PanelRightBlock>
                    <Badge variant="primary" caption={props.badge} />
                </PanelRightBlock>
            ) : null}
        </Panel>
    );
};
AddEmptySource.propTypes = {
    source: PropTypes.object,
    isAccount: PropTypes.bool,
    onClick: PropTypes.func,
    isCreate: PropTypes.bool,
    actionBanner: PropTypes.string,
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    badge: PropTypes.string,
    amplitudePaymentMethodEvent: PropTypes.func,
    setIsNewAccount: PropTypes.func,
};

export default AddEmptySource;
